import React, { useEffect, useState, useCallback } from "react";
import DataTable from "../Components/Common/DataTable";
import SearchBox from "../Components/Common/SearchBox";
import DateRangeFilter from "../Components/Common/DateRangeFilter";
import DeleteButton from "../Components/Common/DeleteButton";
import ViewButton from "./Common/ViewButton";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { downloadExcel } from "../../utils/downloadExcel";
const statusColors = {
  Requested: "#6366f1",       // Indigo
  Pending: "#f59e0b",         // Amber
  "In Progress": "#3b82f6",   // Blue
  Resolved: "#22c55e",        // Green
  Closed: "#6b7280",          // Gray
};


export default function Service({
  login,
  client,
  viewAllVehicleEnq,
  deleteVehicleEnq,
  updateVehicleEnqStatus,
  close_snack_bar,
  snackbar
}) {
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(20);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [editingStatusId, setEditingStatusId] = useState(null);

  const fetchData = useCallback(() => {
    viewAllVehicleEnq(
      login.token,
      login.user_id,
      searchInput,
      page,
      rowsPerPage,
      startDate,
      endDate,
      selectedStatus
    );
  }, [login, searchInput, page, rowsPerPage, startDate, endDate, selectedStatus, viewAllVehicleEnq]);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(fetchData, 300);
    return () => clearTimeout(timer);
  }, [searchInput, fetchData]);

  // Reload on page/rows/date/status change
  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, startDate, endDate, selectedStatus, fetchData]);
  

  const vehicalenq = client?.all_vehicleEnq || [];
  const vehicalenqCount = client?.all_vehicleEnqlength || 0;
  const pageLength = client?.vehicalenq_length || 0;
  // DOWNLOAD EXCEL FUNCTION
  const handleDownloadExcel = () => {
    downloadExcel(
      "vehicleEnq/export-vehicle-enq", // ✅ Correct backend endpoint
      "VehicleEnquiryReport",                  // ✅ File name
      "POST",
      {
        search: searchInput,
        startDate,
        endDate,
        status: selectedStatus,
        user_id: login.user_id,
      },
      login.token
    );
  };

  const columns = [
    {
      header: "Name",
      key: "name",
      render: (row) => `${row.firstName || ""} ${row.lastName || ""}`.trim(),
    },
    { header: "Mobile", key: "mobile" },
    { header: "Email", key: "email" },
    { header: "Car Model", key: "carType" },
    { header: "Dealer", key: "dealer" },
    {
      header: "Created Date",
      key: "createdAt",
      render: (row) => {
        const date = new Date(row.createdAt);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();

        return (
          <span style={{ display: "flex", flexDirection: "column", lineHeight: "16px" }}>
            <span>{formattedDate}</span>
            <span style={{ fontSize: "12px", color: "#555" }}>{formattedTime}</span>
          </span>
        );
      },
    },

    {
      header: "Last Updated",
      key: "updatedAt",
      render: (row) => {
        const date = new Date(row.updatedAt);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();

        return (
          <span style={{ display: "flex", flexDirection: "column", lineHeight: "16px" }}>
            <span>{formattedDate}</span>
            <span style={{ fontSize: "12px", color: "#555" }}>{formattedTime}</span>
          </span>
        );
      },
    },
    {
      header: "Status",
      key: "status",
      render: (row) => {
        const isEditing = editingStatusId === row._id;

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {isEditing ? (
              <select
                autoFocus
                defaultValue={row.status}
                onChange={(e) => {
                  const newStatus = e.target.value;

                  updateVehicleEnqStatus(
                    login.token,
                    login.user_id,
                    row._id,
                    newStatus,
                    page,
                    rowsPerPage
                  );

                  setEditingStatusId(null);
                }}
                onBlur={() => setEditingStatusId(null)} // Close if mouse clicked outside
                style={{
                  padding: "4px 6px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              >
                <option>Requested</option>
                <option>Pending</option>
                <option>In Progress</option>
                <option>Resolved</option>
                <option>Closed</option>
              </select>
            ) : (
              <span
                onClick={() => setEditingStatusId(row._id)}
                style={{
                  padding: "4px 10px",
                  borderRadius: "6px",
                  color: "white",
                  backgroundColor: statusColors[row.status] || "#6b7280",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                {row.status}
              </span>
            )}
          </div>
        );
      },
    },

    {
      header: "Action",
      key: "action",
      render: (row) => (
        <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
          <ViewButton
            fields={[
              { label: "First Name", key: "firstName" },
              { label: "Last Name", key: "lastName" },
              { label: "Mobile", key: "mobile" },
              { label: "Email", key: "email" },
              { label: "Car Model", key: "carType" },
              { label: "Dealer", key: "dealer" },
              { label: "Pincode", key: "pincode" },
              // CREATED DATE DISPLAY FIX
              {
                label: "Created Date",
                key: "createdAt",
                render: (row) => {
                  const d = new Date(row.createdAt);
                  return (
                    <>
                      {d.toLocaleDateString()} <br />
                      <span style={{ fontSize: "12px", color: "#555" }}>
                        {d.toLocaleTimeString()}
                      </span>
                    </>
                  );
                },
              },

              // UPDATED DATE DISPLAY FIX
              {
                label: "Last Updated",
                key: "updatedAt",
                render: (row) => {
                  const d = new Date(row.updatedAt);
                  return (
                    <>
                      {d.toLocaleDateString()} <br />
                      <span style={{ fontSize: "12px", color: "#555" }}>
                        {d.toLocaleTimeString()}
                      </span>
                    </>
                  );
                },
              },
              { label: "Status", key: "status" },
            ]}
            data={row}
            buttonLabel="View"
          />
          <DeleteButton
            item={row}
            viewName="Contact"
            onDelete={(vehicalenq) => deleteVehicleEnq(login.token, login.user_id, vehicalenq._id, page,
              rowsPerPage)}
          />
        </div>
      ),
    },
  ];

  return (
    <div style={{ padding: "15px" }}>
      <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
        Vehical Enquiries ({vehicalenqCount})
      </h2>

      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        {/* Search box */}
        <SearchBox value={searchInput} onChange={setSearchInput} />

        {/* Filters: Status + Date */}
        <div style={{ display: "flex", gap: "8px" }}>
          <select
            style={{
              padding: "6px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e.target.value);
            }}
          >
            <option value="">All</option>
            <option>Requested</option>
            <option>Pending</option>
            <option>In Progress</option>
            <option>Resolved</option>
            <option>Closed</option>
          </select>

          <DateRangeFilter
            onDateChange={({ start, end }) => {
              setStartDate(start);
              setEndDate(end);
            }}
          />
          {/* DOWNLOAD EXCEL BUTTON */}
          <button
            onClick={handleDownloadExcel}
            style={{
              padding: "8px 15px",
              background: "green",
              color: "white",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
            }}
          >
            ⬇  Export Data
          </button>
        </div>
      </div>
      {/* {console.log(totalCount)} */}
      {/* Table */}
      <DataTable
        columns={columns}
        data={vehicalenq}
        page={page}
        rowsPerPage={rowsPerPage}
        totalPage={pageLength}
        onPageChange={(p) => setPage(p)}
      />

      <LoaderCon />
      {/* <Snackbar1
        open={snackbar.response_received}
        onClose={close_snack_bar}
        message={snackbar.message}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      /> */}
    </div>
  );
}

